export default __webpack_public_path__ + "static/media/mianvade.f1f804f0.svg";